module.exports = __webpack_public_path__ + "img/logo.40df176b.png";